module.exports = __webpack_public_path__ + "static/media/Big_Cloud_Up_Red.a448f83d.png";